<template>
  <lego-drop-holder
    :itemWidth="customWidth"
    :items="items"
    :menuDirection="position"
    @click="customClick"
    class="more-actions"
  >
    <lego-icon :size="16" color="#2C59D9" icon-type="df" icon="more" class="move-action__icon" />
  </lego-drop-holder>
</template>

<script setup>
import { defineProps } from 'vue';

//props
const props = defineProps({
  items: {
    type: Array,
    default: []
  },
  position: {
    type: String,
    default: 'left'
  },
  border: {
    type: String,
    default: '1px solid #2c5ad8'
  },
  customWidth: {
    type: Number,
    default: 200
  }
});

// function
const customClick = (item) => {
  item.action();
};
</script>

<style scoped lang="scss">
.move-action {
  &__icon {
    width: 32px;
    height: 32px;
    border-radius: 3px;
    border: v-bind(border);

    &:hover {
      background-color: rgba(54, 79, 199, 0.2);
    }

    &:active {
      background-color: rgba(54, 79, 199, 0.4);
    }
  }
}

:deep(.lego-dropdown-menu) {
  border-color: #2c5ad8;
  border-radius: 4px;

  .lego-dropdown__items {
    .lego-dropdown__item {
      color: #2e3138;

      &:hover {
        background-color: #eef2fc;
      }

      .lego-dropdown__label {
        height: 30px;
        min-height: 30px;
      }

      &.lego-dropdown__disabled {
        .lego-dropdown__label {
          opacity: 1;
          color: #b3b7c1;
        }
      }
    }
  }
}
</style>
